export default __webpack_public_path__ + "static/media/semiCircle.d6f74471.svg";